const getCurrentYear = () => {
  const currentDate = new Date();
  return currentDate.getUTCFullYear();
};

const currentYear = getCurrentYear();

export default currentYear;
